import styled from "@emotion/styled";
import { Button, FormControlLabel } from "@mui/material";

export const SaveButton = styled(Button)({
	placeSelf: "end",
	width: "167.5px"
});

export const AcknowledgementCheckboxText = styled.div(({ theme }) => ({
	"& > div:last-of-type": {
		fontStyle: "italic"
	},
	padding: "8px 0"
}));

export const RadioGroupContainer = styled.div({
	padding: "0 24px"
});

export const AcknowledgementCheckbox = styled(FormControlLabel)({
	display: "flex",
	alignItems: "flex-start"
});
